import { AuthGuard } from '../../shared/guards/AuthGuard';
import { ListagemContratosPresentation } from './components';
import { Sidebar } from '../../shared/components';

export const ListagemContratosPage = (): JSX.Element => {
    return (
        <AuthGuard>
            <Sidebar>
                <ListagemContratosPresentation/>
            </Sidebar>
        </AuthGuard>
    )
};